/**
 * Guest Token Management Utility
 *
 * NOTE: Frontend NEVER self-generates guest tokens.
 * The backend generates guest_token on the first cart mutation and returns it.
 * The frontend only stores, retrieves, and sends it.
 */

const GUEST_TOKEN_KEY = "guest_token";

export const getGuestToken = () => {
  try {
    return localStorage.getItem(GUEST_TOKEN_KEY) || null;
  } catch (err) {
    console.warn("Unable to access localStorage for guest token:", err);
    return null;
  }
};

export const setGuestToken = (token) => {
  try {
    if (token) {
      localStorage.setItem(GUEST_TOKEN_KEY, token);
    } else {
      localStorage.removeItem(GUEST_TOKEN_KEY);
    }
  } catch (err) {
    console.warn("Unable to set guest token in localStorage:", err);
  }
};

export const clearGuestToken = () => {
  try {
    localStorage.removeItem(GUEST_TOKEN_KEY);
  } catch (err) {
    console.warn("Unable to clear guest token from localStorage:", err);
  }
};

export default {
  getGuestToken,
  setGuestToken,
  clearGuestToken,
};
